import { NgModule } from '@angular/core';
import { SimpleStorageService } from "libraries/service/simple-storage/simple-storage.service";
import { LocalStorageModule } from "libraries/service/localStorage/localStorage.module";

@NgModule({
    imports: [
        LocalStorageModule,
    ],
    providers: [
        SimpleStorageService
    ]
})
export class SimpleStorageModule {
}
